module.exports = __webpack_public_path__ + "img/slider_3.4e68ce63.svg";